import type {
  ProductSalesMaterial,
  ProductSalesMaterialCreateRequest,
  ProductSalesMaterialList,
  ProductSalesMaterialUpdateRequest,
} from '@shared/types/product-sales-material';
import { api } from './client';

/// HTTP wrappers for `/api/master/products/:product_id/sales-materials`.
export const productSalesMaterialsApi = {
  list(productId: string): Promise<ProductSalesMaterialList> {
    return api.get<ProductSalesMaterialList>(
      `/api/master/products/${encodeURIComponent(productId)}/sales-materials`,
    );
  },

  create(
    productId: string,
    body: ProductSalesMaterialCreateRequest,
  ): Promise<ProductSalesMaterial> {
    return api.post<ProductSalesMaterial>(
      `/api/master/products/${encodeURIComponent(productId)}/sales-materials`,
      body,
    );
  },

  update(
    productId: string,
    materialId: string,
    body: ProductSalesMaterialUpdateRequest,
  ): Promise<ProductSalesMaterial> {
    return api.patch<ProductSalesMaterial>(
      `/api/master/products/${encodeURIComponent(productId)}/sales-materials/${encodeURIComponent(materialId)}`,
      body,
    );
  },

  delete(productId: string, materialId: string): Promise<void> {
    return api.delete(
      `/api/master/products/${encodeURIComponent(productId)}/sales-materials/${encodeURIComponent(materialId)}`,
    );
  },
};
